// This file is only a template for constants.  Copy and paste this to your application's constants .ts file and start off from there
// Rename all things with App_Name.
// Naming convention for constants is "[App Name]Constants.ts" i.e. UsersConstants.ts, EntitlementConstants.ts

// convention for constants is
// [App_Name]_[Action]

var Viewer3DEvents = {
    DISPLAY_FINISHED: 'DISPLAY_FINISHED',
    SELECTION_CHANGED: 'SELECTION_CHANGED',
    SELECTION_MODE_CHANGED: 'SELECTION_MODE_CHANGED',
    DISPLAY_STARTED: 'DISPLAY_STARTED',
    DISPLAY_IN_PROGRESS: 'DISPLAY_IN_PROGRESS',
    DISPLAY_MEMORY_LIMIT: "DISPLAY_MEMORY_LIMIT",
    RETRIEVING_DATA: 'RETRIEVING_DATA',
    VIEWER_FOCUSING: 'VIEWER_FOCUSING',
    VIEWER_FOCUSED: 'VIEWER_FOCUSED',
    VIEWER_BOX_ZOOMED: 'VIEWER_BOX_ZOOMED',
    MEASUREMENT_ADDED: 'MEASUREMENT_ADDED',
    CAMERA_MODE_CHANGED: 'CAMERA_MODE_CHANGED',
    VIEWER_SETTING_CHANGED: 'VIEWER_SETTING_CHANGED',
    VIEWER_BUSY: 'VIEWER_BUSY',
    VIEWER_IDLE: 'VIEWER_IDLE',
    VIEWER_RESIZED: 'VIEWER_RESIZED',
    CAMERA_CHANGED: 'CAMERA_CHANGED',
    FOV_CHANGED: 'FOV_CHANGED',
    POINT3D_CLICKED: 'POINT3D_CLICKED',
    VOLUME_TAG_CHANGED: 'VOLUME_TAG_CHANGED',
    SCAN_POSITION_HIGHLIGHTED: 'SCAN_POSITION_HIGHLIGHTED',
    SCAN_POSITION_RIGHT_CLICKED: 'SCAN_POSITION_RIGHT_CLICKED',
    ASSEMBLY_CREATED: 'ASSEMBLY_CREATED',
    ASSEMBLY_UPDATED: 'ASSEMBLY_UPDATED'
};

export default Viewer3DEvents;